// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/home/aoki/Projects/personal/concurso-musical/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/home/aoki/Projects/personal/concurso-musical/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

